var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[(_vm.localOrganizations.length > 0)?_c('v-select',{staticClass:"mt-3",attrs:{"id":"local_organization","items":_vm.localOrganizations,"label":"Местна организация","value":_vm.value,"solo":"","clearable":""},on:{"change":_vm.update}}):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }